import useSWR from 'swr';
import { useTranslation } from 'react-i18next';

import { fetchDedaloApi } from './dedaloApi';
import { FragmentSchema, AudiovisualTitleSchema } from '@/schemas/fragmentSchema';

export function useFragments(locators) {
    const { i18n } = useTranslation();
    const key = locators?.length ? ['fragments', JSON.stringify(locators), i18n.language] : null;

    const { data, error, isLoading } = useSWR(key, () =>
        Promise.all(
            locators.map((locator) =>
                fetchDedaloApi(
                    {
                        dedalo_get: 'fragment_from_index_locator',
                        index_locator: JSON.stringify(locator),
                    },
                    FragmentSchema,
                    i18n.language
                )
            )
        ).then((results) => results.map((r) => r?.result ?? null))
    );

    return { data, error, isLoading };
}

export function useAudiovisualTitles(sectionIds) {
    const { i18n } = useTranslation();
    const key = sectionIds?.length ? ['avTitles', JSON.stringify(sectionIds), i18n.language] : null;

    const { data, error, isLoading } = useSWR(key, () =>
        Promise.all(
            sectionIds.map((id) =>
                fetchDedaloApi(
                    { table: 'audiovisual', section_id: id, ar_fields: ['title'] },
                    AudiovisualTitleSchema,
                    i18n.language
                )
            )
        ).then((results) => results.map((r) => r?.result?.[0] ?? null))
    );

    return { data, error, isLoading };
}
